<template>
	<header
		class="header"
		:class="{ open: menuStore.isOpen, scrolled: menuStore.isScrolled, isHidden: isHidden }">
		<div class="header__container container">
			<NuxtLinkLocale to="/#intro" @click="menuStore.isOpen = false">
				<img
					src="/images/logo/banner-veon-logo.svg"
					width="100"
					height="58"
					alt="VEON AdTech Digital"
					class="header__logo white" />
				<img
					src="/images/logo/adtech-logo-black.svg"
					width="100"
					height="42"
					alt="VEON AdTech Digital"
					class="header__logo black" />
			</NuxtLinkLocale>
			<Transition name="nav">
				<BlocksNav v-if="menuStore.isOpen || menuStore.isDesktop || !isViewportResolved" class="header__nav" />
			</Transition>
			<LayoutCover v-model:is-open="menuStore.isOpen" />
			<div class="header__actions">
				<BlocksLangSwitcher class="header__lang-switcher" />
				<BlocksMenuBtn />
			</div>
		</div>
	</header>
</template>

<script setup lang="ts">
	const menuStore = useMenuStore()

	// const isDesktop = ref(window.innerWidth > 992)

	const isHidden = ref(false)
	const isViewportResolved = ref(false)
	let lastScrollY = 0

	function onScroll() {
		if (!import.meta.client) return
		const currentY = window.scrollY
		if (currentY > lastScrollY && currentY > 1) {
			isHidden.value = true
		} else {
			isHidden.value = false
		}
		lastScrollY = currentY
	}

	function onResize() {
		if (!import.meta.client) return
		menuStore.isDesktop = window.innerWidth > 992
		if (!menuStore.isDesktop) {
			menuStore.isOpen = false
		}
	}

	onMounted(() => {
		lastScrollY = window.scrollY
		onResize()
		isViewportResolved.value = true
		// window.addEventListener('scroll', onScroll)
		window.addEventListener('resize', onResize)
	})

	onUnmounted(() => {
		window.removeEventListener('resize', onResize)
		// window.removeEventListener('scroll', onScroll)
	})
</script>

<style scoped lang="scss">
	.nav-enter-active,
	.nav-leave-active {
		clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
		transition:
			opacity 0.3s,
			clip-path 0.4s;
	}
	.nav-enter-from,
	.nav-leave-to {
		// opacity: 0;
		clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
	}
	.header {
		position: absolute;
		top: 0;
		z-index: 100;
		width: 100%;
		padding: 16px 0;

		// backdrop-filter: blur(0.5rem);
		// overflow: hidden;
		transition:
			transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
			0.4s background-color,
			0.4s clip-path;

		// @media (width <= 991.98px) {
		// 	clip-path: polygon(0% 0%, 100% 0%, 100% 18.5%, 0% 18.5%);
		// }
		@media (width <= 991.98px) {
			z-index: 200;
		}

		// &.scrolled {
		// 	background-color: #00000040;
		// 	backdrop-filter: blur(0.5rem);
		// }
		&.open {
			z-index: 3000;
		}

		// &.open {
		// 	clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
		// 	background-color: #00000040;
		// 	backdrop-filter: blur(0.5rem);
		// 	.header__nav {
		// 		opacity: 1;
		// 		transition: 0.4s opacity;
		// 	}
		// }

		// &.onwhite {
		// 	background-color: #00000040;
		// 	// .header__logo {
		// 	// 	&.white {
		// 	// 		display: none;
		// 	// 	}
		// 	// 	&.black {
		// 	// 		display: block;
		// 	// 	}
		// 	// }
		// 	// .header__nav,
		// 	// .header__lang-switcher {
		// 	// 	color: var(--black);
		// 	// }
		// }
		&__logo {
			@media (width <= 575.98px) {
				width: 70px;
			}
			&.black {
				display: none;
			}
		}
		&__container {
			display: flex;
			gap: 32px;
			align-items: center;
			justify-content: space-between;

			@media (width <= 991.98px) {
				flex-wrap: wrap;
			}
		}
		&__actions {
			display: flex;
			gap: 32px;
			align-items: center;
			justify-content: space-between;

			@media (width <= 575.98px) {
				gap: 8px;
			}
		}

		:deep(.header__nav) {
			@media (width <= 991.98px) {
				display: none;
			}
		}

		&.open {
			:deep(.header__nav) {
				@media (width <= 991.98px) {
					display: block;
				}
			}
		}
		&.isHidden {
			transform: translateY(-100%);
		}
	}
</style>
